/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '../../../common/ui/AppSkeletonImage.tsx';
import imgSVG from '../assets/filter-results-edit-skeleton.tpl.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		border: 'none',
	},
});

const FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';

export const FilterResultsEditSkeleton = () => (
	<AppSkeletonImage
		src={imgSVG}
		css={customCssStyles}
		containerStyles={{ height: FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT }}
	/>
);
